module.exports = __webpack_public_path__ + "static/matplotlib-4e18925d6c238450e70351220e9f65fd.svg";